// Backstage catalog browsing for the Sunstone platform.
//
// Provides a read-only snapshot of the Backstage software catalog's
// Component entities, so the UI can list and filter every known service by
// product family (baic, mai, csai, a8) regardless of whether Sunstone has
// deployed it.
//
// Authentication: valid JWT required (requiresAuth: true).
//
// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file components/v1/components.proto (package components.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file components/v1/components.proto.
 */
export const file_components_v1_components: GenFile = /*@__PURE__*/
  fileDesc("Ch5jb21wb25lbnRzL3YxL2NvbXBvbmVudHMucHJvdG8SDWNvbXBvbmVudHMudjEiOAoJQ29tcG9uZW50EgwKBG5hbWUYASABKAkSDgoGZmFtaWx5GAIgASgJEg0KBW93bmVyGAMgASgJIhcKFUxpc3RDb21wb25lbnRzUmVxdWVzdCJGChZMaXN0Q29tcG9uZW50c1Jlc3BvbnNlEiwKCmNvbXBvbmVudHMYASADKAsyGC5jb21wb25lbnRzLnYxLkNvbXBvbmVudCI4Ch9SZXNvbHZlQ29tcG9uZW50RmFtaWxpZXNSZXF1ZXN0EhUKDXNlcnZpY2VfbmFtZXMYASADKAkiyAEKIFJlc29sdmVDb21wb25lbnRGYW1pbGllc1Jlc3BvbnNlEmgKFmZhbWlseV9ieV9zZXJ2aWNlX25hbWUYASADKAsySC5jb21wb25lbnRzLnYxLlJlc29sdmVDb21wb25lbnRGYW1pbGllc1Jlc3BvbnNlLkZhbWlseUJ5U2VydmljZU5hbWVFbnRyeRo6ChhGYW1pbHlCeVNlcnZpY2VOYW1lRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ATL6AQoRQ29tcG9uZW50c1NlcnZpY2USYgoOTGlzdENvbXBvbmVudHMSJC5jb21wb25lbnRzLnYxLkxpc3RDb21wb25lbnRzUmVxdWVzdBolLmNvbXBvbmVudHMudjEuTGlzdENvbXBvbmVudHNSZXNwb25zZSIDkAIBEoABChhSZXNvbHZlQ29tcG9uZW50RmFtaWxpZXMSLi5jb21wb25lbnRzLnYxLlJlc29sdmVDb21wb25lbnRGYW1pbGllc1JlcXVlc3QaLy5jb21wb25lbnRzLnYxLlJlc29sdmVDb21wb25lbnRGYW1pbGllc1Jlc3BvbnNlIgOQAgFCR1pFZ2l0aHViLmNvbS91bmlwaG9yZS9zdW5zdG9uZS9wa2cvZ28vZ2VuL3BiL2NvbXBvbmVudHMvdjE7Y29tcG9uZW50c1YxYgZwcm90bzM");

/**
 * Component is a single Backstage catalog entity.
 *
 * @generated from message components.v1.Component
 */
export type Component = Message<"components.v1.Component"> & {
  /**
   * Backstage catalog entity name.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Product family: "baic", "mai", "csai", "a8", or "" if unannotated.
   *
   * @generated from field: string family = 2;
   */
  family: string;

  /**
   * Primary owner name, or "" if unannotated.
   *
   * @generated from field: string owner = 3;
   */
  owner: string;
};

/**
 * Describes the message components.v1.Component.
 * Use `create(ComponentSchema)` to create a new message.
 */
export const ComponentSchema: GenMessage<Component> = /*@__PURE__*/
  messageDesc(file_components_v1_components, 0);

/**
 * ListComponentsRequest has no fields — it returns the full Backstage
 * catalog snapshot, not a filtered or paginated view.
 *
 * @generated from message components.v1.ListComponentsRequest
 */
export type ListComponentsRequest = Message<"components.v1.ListComponentsRequest"> & {
};

/**
 * Describes the message components.v1.ListComponentsRequest.
 * Use `create(ListComponentsRequestSchema)` to create a new message.
 */
export const ListComponentsRequestSchema: GenMessage<ListComponentsRequest> = /*@__PURE__*/
  messageDesc(file_components_v1_components, 1);

/**
 * @generated from message components.v1.ListComponentsResponse
 */
export type ListComponentsResponse = Message<"components.v1.ListComponentsResponse"> & {
  /**
   * @generated from field: repeated components.v1.Component components = 1;
   */
  components: Component[];
};

/**
 * Describes the message components.v1.ListComponentsResponse.
 * Use `create(ListComponentsResponseSchema)` to create a new message.
 */
export const ListComponentsResponseSchema: GenMessage<ListComponentsResponse> = /*@__PURE__*/
  messageDesc(file_components_v1_components, 2);

/**
 * ResolveComponentFamiliesRequest carries deployed service names (as
 * recorded in a tenant's release manifest) to resolve against the catalog.
 * These names don't always match the catalog's canonical component name
 * exactly — see ResolveComponentFamilies.
 *
 * @generated from message components.v1.ResolveComponentFamiliesRequest
 */
export type ResolveComponentFamiliesRequest = Message<"components.v1.ResolveComponentFamiliesRequest"> & {
  /**
   * @generated from field: repeated string service_names = 1;
   */
  serviceNames: string[];
};

/**
 * Describes the message components.v1.ResolveComponentFamiliesRequest.
 * Use `create(ResolveComponentFamiliesRequestSchema)` to create a new message.
 */
export const ResolveComponentFamiliesRequestSchema: GenMessage<ResolveComponentFamiliesRequest> = /*@__PURE__*/
  messageDesc(file_components_v1_components, 3);

/**
 * @generated from message components.v1.ResolveComponentFamiliesResponse
 */
export type ResolveComponentFamiliesResponse = Message<"components.v1.ResolveComponentFamiliesResponse"> & {
  /**
   * Keyed by the requested service name. Only names that resolved to a
   * component with a non-empty family are present; callers should treat a
   * missing key as unresolved.
   *
   * Values are usually one of "baic", "mai", "csai", "a8" (the catalog's own
   * product families), but can also be "infra" - a value that never comes
   * from a Backstage catalog annotation. It's assigned by this RPC itself to
   * third-party platform infrastructure (Temporal, Flyte, etc.) that ships
   * as several subcomponents with no per-service catalog entry of their own.
   * UI consumers should have a badge/filter case for "infra" alongside the
   * catalog families, not just the four above.
   *
   * @generated from field: map<string, string> family_by_service_name = 1;
   */
  familyByServiceName: { [key: string]: string };
};

/**
 * Describes the message components.v1.ResolveComponentFamiliesResponse.
 * Use `create(ResolveComponentFamiliesResponseSchema)` to create a new message.
 */
export const ResolveComponentFamiliesResponseSchema: GenMessage<ResolveComponentFamiliesResponse> = /*@__PURE__*/
  messageDesc(file_components_v1_components, 4);

/**
 * @generated from service components.v1.ComponentsService
 */
export const ComponentsService: GenService<{
  /**
   * ListComponents returns every Component entity currently known to the
   * Backstage catalog. Fails with CodeUnavailable if Backstage is not
   * configured for this environment, since it's the only data source —
   * an empty list would otherwise look identical to "catalog has zero
   * components".
   *
   * @generated from rpc components.v1.ComponentsService.ListComponents
   */
  listComponents: {
    methodKind: "unary";
    input: typeof ListComponentsRequestSchema;
    output: typeof ListComponentsResponseSchema;
  },
  /**
   * ResolveComponentFamilies maps deployed service names to their product
   * family. Deployed names sometimes carry a tenant-specific naming
   * qualifier or an old/abbreviated form of the catalog's canonical name
   * (see internal/management/backstage's CatalogCache.resolve), so this is
   * not a plain lookup by exact name.
   *
   * @generated from rpc components.v1.ComponentsService.ResolveComponentFamilies
   */
  resolveComponentFamilies: {
    methodKind: "unary";
    input: typeof ResolveComponentFamiliesRequestSchema;
    output: typeof ResolveComponentFamiliesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_components_v1_components, 0);

